import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty } from 'ramda-extension';

import InfoCircleTooltip from 'components/atoms/GefMui/InfoCircleTooltip';

export const InformationSettingSwitch = ({ description, value, onChange, tooltip }) => {
	return (
		<Stack
			direction="row"
			spacing={1}
			//eslint-disable-next-line
			sx={(theme) => ({
				alignItems: 'center',
				'.MuiSvgIcon-root': { fontSize: theme.gkcl?.svgIcon?.size15 },
			})}
		>
			<Switch checked={value} onChange={onChange} />
			<Typography variant="body3">{description}</Typography>
			{!isNilOrEmpty(tooltip) && <InfoCircleTooltip text={tooltip} />}
		</Stack>
	);
};

InformationSettingSwitch.propTypes = {
	description: PropTypes.string,
	onChange: PropTypes.func,
	tooltip: PropTypes.string,
	value: PropTypes.bool,
};

export default InformationSettingSwitch;
